import { CookieService } from "core-library/services/cookie.service";

export class AccessibilityPaneComponent {

    private readonly _cookieService = new CookieService();

    private _currentStyle = "";
    private _currentFontSize = "";
    private _cookieKey: string = null;
    private _cookieSplitter: string = null;

    private _currentContext: JQuery = null;
    private _fontSizeButtons: JQuery = null;
    private _styleButtons: JQuery = null;
    private _stylesheets: JQuery = null;
    private _html: JQuery = null;

    private _cookieOptions: object = { };

    private setCookie(): void {
        this._cookieService.set(this._cookieKey, `${this._currentFontSize}${this._cookieSplitter}${this._currentStyle}`, this._cookieOptions);
    }

    private getCookie(): string {
        return this._cookieService.get(this._cookieKey);
    }

    private setFontSize(size: string): void {
        this._html.css("font-size", size);

        this._currentFontSize = size;
        this.setCookie();
    }

    private setStyleSheet(style: string): void {
        this._stylesheets.each((index: number, element: HTMLElement) => {
            const stylesheet = $(element);
            const isStylesheetDisabled = stylesheet.attr("data-contrast") !== style;
            stylesheet.prop("disabled", isStylesheetDisabled);
        });

        this._currentStyle = style;
        this.setCookie();
    }

    private tryReadCookie(): boolean {
        try {
            const cookie = this.getCookie();
            if (!cookie) {
                return false;
            }

            const cookieContent = cookie.split(this._cookieSplitter);
            this._currentFontSize = cookieContent[0];
            this._currentStyle = cookieContent[1];
            return true;
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    private setInitialValues(): void {
        if (this.tryReadCookie()) {
            this.setFontSize(this._currentFontSize);
            this.setStyleSheet(this._currentStyle);
        }

        const now = new Date();
        // eslint-disable-next-line @typescript-eslint/dot-notation
        this._cookieOptions["expires"] = now.setTime(now.getTime() + (100 * 24 * 60 * 60 * 1000)); // 100 days to expire
    }

    private bindEvents(): void {
        this._fontSizeButtons.on("click", (event: Event) => {
            const fontSize = $(event.target).attr("data-font-size");
            this.setFontSize(fontSize);
        });

        this._styleButtons.on("click", () => {
            const contrast = $(event.target).attr("data-contrast");
            this.setStyleSheet(contrast);
        });
    }

    private parseContext(): void {
        this._html = $("html");
        this._fontSizeButtons = $(".js-accessibility-pane__font-size", this._currentContext);
        this._styleButtons = $(".js-accessibility-pane__contrast", this._currentContext);
        this._stylesheets = $(".js-contrast-style");
    }

    public init(context: JQuery, cookieKey: string, cookieSplitter: string): void {
        this._currentContext = context || this._currentContext;
        this._cookieKey = cookieKey || this._cookieKey;
        this._cookieSplitter = cookieSplitter || this._cookieSplitter;

        this.parseContext();
        this.bindEvents();
        this.setInitialValues();
    }

    public static init(context: JQuery, cookieKey: string, cookieSplitter: string): AccessibilityPaneComponent {
        const component = new AccessibilityPaneComponent();
        component.init(context, cookieKey, cookieSplitter);
        return component;
    }
}
